<template>
  <div class="profile">
    <h1>Profile</h1>
    <h2>{{user.name}}</h2>
    <dl>
      <dt>Picture</dt>
      <dd><avatar :user="user" /></dd>
    </dl>
    <dl>
      <dt>Email address</dt>
      <dd>{{user.email}}</dd>
    </dl>
    <dl>
      <dt>Username</dt>
      <dd>{{user.username}}</dd>
    </dl>
    <router-link :to="{ name: 'profileEdit' }" class="button">Edit profile</router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Avatar from './Avatar'
export default {
  computed: {
    ...mapGetters({
      user: 'user'
    }),
  },
  components: {
    Avatar,
  },
}
</script>

<style lang="stylus" scoped>
.profile
  padding 0 30px
</style>
